module.exports = __webpack_public_path__ + "img/para_todo_tipo_de_recubrimientos_ceramicos.a0144cd9.png";